export class mdlCheckPromoCodeReq {
    public Insured_IdNo: string;
    public SequenceNo: string;
    public CustomId: string;
    public PromoCode: string;
    public ProductCode: string;
    public ChassisNo: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlCheckPromoCodeReq.ts